export const host = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
export const registerRoute = `/api/auth/register`;
export const loginRoute = `/api/auth/login`;
export const logoutRoute = `/api/auth/logout`;
export const setAvatarRoute = `/api/setavatar`;
export const allUsersRoute = `/api/allusers`;
export const sendMessageRoute = `/api/messages/addmessage`;
export const getAllMessagesRoute = `/api/messages/getmessages`;